import { render, staticRenderFns } from "./comp_dpc-ListCardWithIcon.vue?vue&type=template&id=029846ca&scoped=true&"
import script from "./comp_dpc-ListCardWithIcon.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-ListCardWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-ListCardWithIcon.vue?vue&type=style&index=0&id=029846ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029846ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
